export const baseAuthorCRUDModels = ['pen-name', 'book', 'arc-team', 'arc', 'review', 'category', 'message']

export abstract class AuthorRole {
  // CRUD operation permissions
  create: string[] = baseAuthorCRUDModels
  read: string[] = baseAuthorCRUDModels.concat(['billing'])
  update: string[] = baseAuthorCRUDModels
  delete: string[] = baseAuthorCRUDModels

  // Generic Boolean Permissions
  maxParticipantsPerArc: number = 0
  maxRunningArcs: number = 0
  canCreatePrivateArcs: boolean = false
  canHaveVIPTeamMembers: boolean = false
  canCreateAudioBookArcs: boolean = false
  canScheduleArcs: boolean = false
  canLimitReviewersToAllOnSeries: boolean = false
  canIdentifyPiracy: boolean = false
  canRequireReviewOnPreviousBooksInSeries: boolean = false
  canShowSocialLinksOnAuthorPages: boolean = false
  canLimitReviewersToTopReviewersOnly: boolean = false
  canAccessPremiumSupport: boolean = false
  canUseAdvancedReviewIssueDetection: boolean = false
  canAddVirtualAssistants: boolean = false
  canViewExtendedReviewerInformation: boolean = false
  canHaveNeverEndingArcs: boolean = false
  canChooseDefaultReviewDisclaimer: boolean = false
  canFreeTypePenNames: boolean = false
  canChooseBrandedDefaultReviewDisclaimer: boolean = false
  canHaveTeamFollowers: boolean = false
}
